export default {
  title01: "Aktuelles Wetter",
  title02: "24 Stunden",
  title03: "10-Tage-Wettervorhersage anzeigen",
  title04: "AQI",
  title05: "Alle Informationen anzeigen",
  title06: "SONNENAUF- UND UNTERGANG",
  title07: "MONDPHASE",
  title08: "Der nächste Vollmond",
  title09: "Der nächste Neumond",
  title10: "TAG",
  title11: "NACHT",
  title12: "Sonnenaufgang",
  title13: "Sonnenuntergang",
  title14: "Mondaufgang",
  title15: "Monduntergang",
  title16: "Quelle",
  title17: "Start",
  title18: "Ende",
  title19: "Aktuellen Standort verwenden",
  title20: "Stadt suchen",
  title21: "Gefühlte Temperatur",
  title22: "Gefühlte Temperatur im Schatten",
  title23: "Jetzt",
  title24: "Heute",
  title25: "SO",
  title26: "MO",
  title27: "DI",
  title28: "MI",
  title29: "DO",
  title30: "FR",
  title31: "SA",
  title32: "Wird geladen...",
  title33: "Jetzt",
  title34: "Stündlich",
  title35: "Täglich",
  title36: "Sonne und Mond",
  title37: "Luftqualität",
  title38: "Kontakt: xlf550402@gmail.com",
  title39: "Datenschutzerklärung",
  title40: "Urheberrecht © comfortweather.com 2020 - 2026. Alle Rechte vorbehalten.",
  title41: "Daten bereitgestellt von",
  title42: "Max",
  title43: "Min",
  title44: "Akzeptieren",
  title45:
    "Danke, dass Sie ComfortWeather nutzen! Um Ihre gesetzlichen Rechte und Interessen besser zu schützen, lesen Sie bitte die ",
  title46: "Datenschutzrichtlinie",
  title47: " sorgfältig vor der Nutzung.",
  title48: "",
  title49: "Kontakt: xyjph123@gmail.com",
  title50: "Urheberrecht © 24hweather.com 2020 - 2026. Alle Rechte vorbehalten.",
  title51:
    "Danke, dass Sie 24hweather nutzen! Um Ihre gesetzlichen Rechte und Interessen besser zu schützen, lesen Sie bitte die ",
  title52: "Ihr Standort hat sich geändert. Möchten Sie ihn aktualisieren?",
  title53: "Bestätigen",
  title54: "Abbrechen",
  title55: "Zurück",
  title56: "Nachrichten",
  title57: "Wetter wird aktualisiert...",
  title58: "Wetter aktualisiert",
  title59: "Alle anzeigen",
  title60: "Urheberrecht © mobi321.com 2020 - 2026. Alle Rechte vorbehalten.",
  title61: "Gestern",
  title62: "Morgen",
  title63: "15-Tage-Wettervorhersage anzeigen",
  title64: "Heutige Details",
  title65: "Rahu Kaal",
  title66: "Alltagsindizes",
  title67: "Alltagsindizes",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Schwer zu trocknen",
  title103: "Langsame trocknung",
  title104: "Trocknet gut",
  title105: "Schnelles trocknen",
  title106: "Sehr schnelles trocknen",

  title107: "Nicht geeignet",
  title108: "Bescheidene erfahrung",
  title109: "Gut für wasseraktivitäten",
  title110: "Sehr geeignet",
  title111: "Perfekte bedingungen",

  title112: "Gesundheitsfördernd",
  title113: "Neutrale bedingungen",
  title114: "Leicht höheres risiko",
  title115: "Hohes risiko",
  title116: "Extremes risiko",

  title117: "Nicht geeignet",
  title118: "Etwas geeignet",
  title119: "Gut für aktivitäten im freien",
  title120: "Sehr geeignet",
  title121: "Ausgezeichnete bedingungen",

  title122: "Sehr trockene bedingungen",
  title123: "Wahrscheinlich trocken",
  title124: "Leicht trocken",
  title125: "Wahrscheinlich nicht trocken",
  title126: "Sehr unwahrscheinlich trocken",

  title127: "Nicht empfohlen",
  title128: "Akzeptabel",
  title129: "Guter tag",
  title130: "Sehr gute bedingungen",
  title131: "Ideale bedingungen",
};
